// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import Root from './Root';

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    ((document.getElementById('app'): any): Element)
  );
};

render(Root);

if (module.hot) {
  module.hot.accept('./Root', () => {
    console.log('Hotreloading App Root');
    render(Root);
  });
}



// WEBPACK FOOTER //
// ./src/index.js